import React from "react";
import "./clientes.css";
import belabeautybarretos from "./images/logo-belabeautybarretos.png";
import dentistaencantada from "./images/logo-dentistaencantada.png";
import laguspastelaria from "./images/logo-laguspastelaria.png";
import rhainarafisioterapeuta from "./images/logo-rhainarafisioterapeuta.png";
import camilanorvete from "./images/logo-camilanorvete.png";
import cpoi_pediatria from "./images/logo-cpoi_pediatria.png";
import deupraiabarretos from "./images/logo-deupraiabarretos.png";
import draericaferrari from "./images/logo-draericaferrari.png";
import drapatriciaandrade from "./images/logo-drapatriciaandrade.png";
import giceliluna from "./images/logo-giceliluna.png";
import rfstore_10 from "./images/logo-rfstore_10.png";
import thaisornellas_bolos from "./images/logo-thaisornellas_bolos.png";
import cartoesdecreditoaltarenda from "./images/logo-cartoesdecreditoaltarenda.png";
import ct_cleyton_alencar from "./images/logo-ct_cleyton_alencar.png";
import edervieiraoficial from "./images/logo-edervieiraoficial.png";
import juliagarciabeauty from "./images/logo-juliagarciabeauty.png";
import linksvibe from "./images/logo-linksvibe.png";
import lsx_agrofert from "./images/logo-lsx_agrofert.png";
import cavesanarquitetura from "./images/logo-cavesanarquitetura.png";
import danilo_serrano from "./images/logo-danilo_serrano.png";
import flabernardi_ from "./images/logo-flabernardi_.png";
import livia_santos_gastronomia from "./images/logo-livia_santos_gastronomia.png";

const clientesData = [
    { name: "Bela Beauty Barretos", logo: belabeautybarretos, link: "https://linksvibe.com.br/belabeautybarretos" },
    { name: "Camila Cavesan - Arquitetura", logo: cavesanarquitetura, link: "https://linksvibe.com.br/cavesanarquitetura" },
    { name: "Camila Norvete", logo: camilanorvete, link: "https://linksvibe.com.br/camilanorvete" },
    { name: "Cartões de Crédito Alta Renda", logo: cartoesdecreditoaltarenda, link: "https://linksvibe.com.br/cartoesdecreditoaltarenda" },
    { name: "CPOI Pediatria", logo: cpoi_pediatria, link: "https://linksvibe.com.br/cpoi_pediatria" },
    { name: "CT Cleyton Alencar", logo: ct_cleyton_alencar, link: "https://linksvibe.com.br/ct_cleyton_alencar" },
    { name: "Danilo Serrano", logo: danilo_serrano, link: "https://linksvibe.com.br/danilo_serrano" },
    { name: "Dentista Encantada", logo: dentistaencantada, link: "https://linksvibe.com.br/dentistaencantada" },
    { name: "Deu praia - Barretos", logo: deupraiabarretos, link: "https://linksvibe.com.br/deupraiabarretos" },
    { name: "Eder Vieira Oficial", logo: edervieiraoficial, link: "https://linksvibe.com.br/edervieiraoficial" },
    { name: "Erica Ferrari", logo: draericaferrari, link: "https://linksvibe.com.br/draericaferrari" },
    { name: "Flávia de Oliveira Bernardi", logo: flabernardi_, link: "https://linksvibe.com.br/flabernardi_" },
    { name: "Giceli Luna", logo: giceliluna, link: "https://linksvibe.com.br/giceliluna" },
    { name: "Júlia Garcia Beauty", logo: juliagarciabeauty, link: "https://linksvibe.com.br/juliagarciabeauty" },
    { name: "Lagus Pastelaria", logo: laguspastelaria, link: "https://linksvibe.com.br/laguspastelaria" },
    { name: "Links Vibe", logo: linksvibe, link: "https://linksvibe.com.br/linksvibe" },
    { name: "Lívia Santos Roncaratti", logo: livia_santos_gastronomia, link: "https://linksvibe.com.br/livia_santos_gastronomia" },
    { name: "LSX Agrofert", logo: lsx_agrofert, link: "https://linksvibe.com.br/lsx_agrofert" },
    { name: "Patricia Andrade", logo: drapatriciaandrade, link: "https://linksvibe.com.br/drapatriciaandrade" },
    { name: "RF Store", logo: rfstore_10, link: "https://linksvibe.com.br/rfstore_10" },
    { name: "Rhainara Fisioterapeuta", logo: rhainarafisioterapeuta, link: "https://linksvibe.com.br/rhainarafisioterapeuta" },
    { name: "Thais Ornellas Bolos", logo: thaisornellas_bolos, link: "https://linksvibe.com.br/thaisornellas_bolos" },
];

// Duplica os clientes para criar o efeito de loop infinito
const duplicado = [...clientesData, ...clientesData];

const Clientes: React.FC = () => {
    return (
        <section id="clientes">
            <div className="clientes-text">
                <h1 className="mb-5 text-center">Clientes</h1>
            </div>
            <div className="carrossel-container">
                <div className="carrossel">
                    {duplicado.map((cliente, index) => (
                        <a key={index} href={cliente.link} className="cliente-item" target="_blank" rel="noopener noreferrer">
                            <img src={cliente.logo} alt={cliente.name} className="img-fluid" />
                        </a>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Clientes;
